"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _authorize = _interopRequireDefault(require("./helpers/authorize"));

var _getEncodedVerifierKey = _interopRequireDefault(require("./helpers/getEncodedVerifierKey"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var getCodeFromLocation = function getCodeFromLocation(_ref) {
  var location = _ref.location;
  var split = location.toString().split('?');

  if (split.length < 2) {
    return null;
  }

  var pairs = split[1].split('&');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var pair = _step.value;

      var _pair$split = pair.split('='),
          _pair$split2 = _slicedToArray(_pair$split, 2),
          key = _pair$split2[0],
          value = _pair$split2[1];

      if (key === 'code') {
        return decodeURIComponent(value || '');
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
};

var fetchToken = function fetchToken(_ref2) {
  var clientId = _ref2.clientId,
      clientSecret = _ref2.clientSecret,
      code = _ref2.code,
      verifier = _ref2.verifier,
      tokenEndpoint = _ref2.tokenEndpoint,
      _ref2$fetch = _ref2.fetch,
      fetch = _ref2$fetch === void 0 ? window.fetch : _ref2$fetch;
  var payload = {
    client_secret: clientSecret,
    client_id: clientId,
    code: code,
    grant_type: 'authorization_code',
    code_verifier: verifier
  };
  return fetch(tokenEndpoint, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(payload)
  }).then(function (r) {
    if (!r.ok) {
      throw new Error("Token response not ok, status is ".concat(r.status, ", check the react-u5auth configuration (wrong provider or token endpoint?)"));
    }

    return r.json();
  }).then(function (token) {
    var expires_in = token.expires_in;

    if (expires_in && Number.isFinite(expires_in)) {
      var slackSeconds = 10; // add 'expires_at', with the given slack

      token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - slackSeconds * 1000);
    }

    return token;
  }).catch(function (err) {
    console.error('ERR (fetch)', err);
    throw err;
  });
};

var removeCodeFromLocation = function removeCodeFromLocation() {
  var _window$location$href = window.location.href.split('?'),
      _window$location$href2 = _slicedToArray(_window$location$href, 2),
      base = _window$location$href2[0],
      search = _window$location$href2[1];

  if (!search) {
    return;
  }

  var newSearch = search.split('&').map(function (param) {
    return param.split('=');
  }).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return key !== 'code';
  }).map(function (keyAndVal) {
    return keyAndVal.join('=');
  }).join('&');
  window.history.replaceState(window.history.state, null, base + (newSearch.length ? "?".concat(newSearch) : ''));
};

var getVerifierFromStorage = function getVerifierFromStorage(_ref5) {
  var clientId = _ref5.clientId,
      storage = _ref5.storage;
  var key = (0, _getEncodedVerifierKey.default)(clientId);
  var value = storage.getItem(key);
  return value;
};

var removeVerifierFromStorage = function removeVerifierFromStorage(_ref6) {
  var clientId = _ref6.clientId,
      storage = _ref6.storage;
  var key = (0, _getEncodedVerifierKey.default)(clientId);
  storage.removeItem(key);
};

var _default = function _default(_ref7) {
  var clientId = _ref7.clientId,
      clientSecret = _ref7.clientSecret,
      provider = _ref7.provider,
      _ref7$tokenEndpoint = _ref7.tokenEndpoint,
      tokenEndpoint = _ref7$tokenEndpoint === void 0 ? "".concat(provider, "/token") : _ref7$tokenEndpoint,
      _ref7$storage = _ref7.storage,
      storage = _ref7$storage === void 0 ? sessionStorage : _ref7$storage,
      _ref7$fetch = _ref7.fetch,
      fetch = _ref7$fetch === void 0 ? window.fetch : _ref7$fetch;
  var context = (0, _react.createContext)({});
  var Provider = context.Provider;

  var Authenticated =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Authenticated, _React$Component);

    function Authenticated() {
      _classCallCheck(this, Authenticated);

      return _possibleConstructorReturn(this, _getPrototypeOf(Authenticated).apply(this, arguments));
    }

    _createClass(Authenticated, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var ensureAuthenticated = this.context.ensureAuthenticated;
        ensureAuthenticated();
      }
    }, {
      key: "render",
      value: function render() {
        var token = this.context.token;
        var children = this.props.children;

        if (!token) {
          return _react.default.createElement("p", null, "logging in..."); // TODO: configurable component here
        } else {
          return children;
        }
      }
    }]);

    return Authenticated;
  }(_react.default.Component);

  _defineProperty(Authenticated, "contextType", context);

  var useToken = function useToken() {
    var _useContext = (0, _react.useContext)(context),
        token = _useContext.token;

    if (!token) {
      console.warn("Trying to useToken() while not being authenticated.\nMake sure to useToken() only inside of an <Authenticated /> component.");
    }

    return token;
  };

  return {
    AuthContext: function AuthContext(_ref8) {
      var children = _ref8.children;

      var _useState = (0, _react.useState)(null),
          _useState2 = _slicedToArray(_useState, 2),
          token = _useState2[0],
          setToken = _useState2[1]; // if we have no token, but code and verifier are present,
      // then we try to swap code for token


      (0, _react.useEffect)(function () {
        if (!token) {
          var code = getCodeFromLocation({
            location: window.location
          });
          var verifier = getVerifierFromStorage({
            clientId: clientId,
            storage: storage
          });

          if (code && verifier) {
            fetchToken({
              clientId: clientId,
              clientSecret: clientSecret,
              tokenEndpoint: tokenEndpoint,
              code: code,
              verifier: verifier,
              fetch: fetch
            }).then(setToken).then(function () {
              removeCodeFromLocation();
              removeVerifierFromStorage({
                clientId: clientId,
                storage: storage
              });
            }).catch(function (e) {
              console.error(e);
              alert("Error fetching auth token: ".concat(e.message));
            });
          }
        }
      }, [token]);

      var ensureAuthenticated = function ensureAuthenticated() {
        var code = getCodeFromLocation({
          location: window.location
        });

        if (!token && !code) {
          (0, _authorize.default)({
            provider: provider,
            clientId: clientId
          });
        }
      };

      return _react.default.createElement(Provider, {
        value: {
          token: token,
          ensureAuthenticated: ensureAuthenticated
        }
      }, children);
    },
    Authenticated: Authenticated,
    useToken: useToken
  };
};

exports.default = _default;